import { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ApiService from "../service/ApiService";

export function useReCaptchaValidation() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isValidReCaptcha, setIsValidReCaptcha] = useState(false);
  const [errorReCaptcha, setErrorReCaptcha] = useState<string | null>(null);
  const apiService = new ApiService();

  const validateReCaptcha = async (action = "checkout"): Promise<boolean> => {
    try {
      if (!executeRecaptcha) {
        throw new Error("reCAPTCHA não está disponível");
      }

      // Gera o token do reCAPTCHA
      const reCaptchaToken = await executeRecaptcha(action);

      // Envia o token para o backend para validação
      const data = await apiService.verifyReCaptcha(reCaptchaToken);

      // Verifica se a resposta do backend foi bem-sucedida
      const isValid = data.success;
      setIsValidReCaptcha(isValid);
      
      if (!isValid) {
        throw new Error(data.message || "Falha na verificação do reCAPTCHA");
      }

      return isValid;
    } catch (err: any) {
      console.error("🚀 ~ validateReCaptcha ~ err message:", err.message);
      setErrorReCaptcha(`ReCaptcha: ${err.message}`);
      setIsValidReCaptcha(false);
      alert(err.message || "Falha na verificação do reCAPTCHA");
      return false;
    }
  };

  return {
    isValidReCaptcha,
    validateReCaptcha,
    errorReCaptcha,
  };
};
